export const tableHeight = (headerHeight) => {
  const clientHeight = window.innerHeight;
  return clientHeight - 40 - headerHeight;
}
